import { CloseOutlined } from '@ant-design/icons';
import { THEME } from '@common/constants/theme.constant';
import { Tooltip as AntTooltip, TooltipProps } from 'antd';
import React, { useMemo, useState } from 'react';

type IProps = {
    type: 'info' | 'error' | 'success';
    title: string;
} & TooltipProps;

export const Tooltip = ({ type, title, ...rest }: IProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState(false);

    const handleTooltipVisibility = (): void => {
        setIsOpen(!isOpen);
    };

    const toolTipTitle = useMemo(
        () => (
            <>
                <CloseOutlined style={styles.closeBtn} onClick={(): void => setIsOpen(false)} />
                <p style={styles.title}>{title}</p>
            </>
        ),
        [title],
    );

    return (
        <div>
            <AntTooltip
                title={toolTipTitle}
                zIndex={0}
                onVisibleChange={handleTooltipVisibility}
                visible={isOpen}
                trigger={['click', 'hover']}
                color={backgroundColour[type]}
                overlayInnerStyle={{
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    padding: '12px',
                    fontSize: '14px',
                    fontWeight: 300,
                    borderRadius: '6px',
                    gap: '16px',
                    margin: 0,
                }}
                {...rest}
            />
        </div>
    );
};

const backgroundColour = {
    info: `${THEME.TEXT_BLACK}`,
    error: `${THEME.PINK}`,
    success: `${THEME.LIGHT_GREEN}`,
};

const styles = {
    closeBtn: {
        margin: 'auto',
    },
    title: {
        margin: 0,
    },
};
